var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{class:{
    'document-chooser-item-selected': _vm.selected
  },attrs:{"link":""},on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_c('v-list-item-title',{staticClass:"previewable-item-list-item"},[_c('div',{staticClass:"previewable-item-label previewable-item-label-stop-text-from-overflowing"},[_vm._v(" "+_vm._s(_vm.item.label || _vm.item.url)+" ")]),_c('div',{staticClass:"previewable-item-type"},[_vm._v(_vm._s(_vm.item.type))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }